import { StateService, type FormService } from '@stepform';

export class MentalHealthStateService extends StateService {
  public canProceedToNextStep(formService: FormService): boolean {
    const permissionToRaise = formService.getQuestionById('PermissionToRaise');

    if (
      permissionToRaise?.hasPopulatedAnswer() &&
      permissionToRaise.answer === 'no'
    ) {
      return false;
    }

    return super.canProceedToNextStep(formService);
  }
}
